import React, { useState, useEffect} from 'react';
import './App.css';

import SearchBar from './SearchBar';
import SearchResults from './SearchResults';
import Playlist from './Playlist';
import Spotify from './util/Spotify';


function App() {
    const [searchResults, setSearchResults] = useState([]); //This is state used locally at the App.js component level
    const [playlist, setPlaylist] = useState([]); //This is passed to the SearchResults anf PlayList components so that they can share state

    const search = async (input) => {
        const results = await Spotify.search(input);
        setSearchResults(results);

        console.log(searchResults);
    }

    const savePlaylist = (name, trackUris) => {
        Spotify.savePlaylist(name, trackUris);
    }

    const getPreview = (trackID) => {
        Spotify.getTrackPreview(trackID);
    }

    useEffect(() => {
        console.log(searchResults);
    }, [searchResults]);


    return (
        <div className='body'>
            <header>
                <svg viewBox='0 0 450 100'>
                    <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle">Jammming</text>
                </svg>
            </header>
            <main>
                <SearchBar onSearch={search}/>
                <div className='main-container'>
                    <div className='results'>
                        <SearchResults 
                            searchResults={searchResults} 
                            setPlaylist={setPlaylist} 
                            getPreview={getPreview}
                        />
                    </div>
                    <div>
                        <Playlist setPlaylist={setPlaylist} playlist={playlist} savePlaylist={savePlaylist}/>
                    </div>
                </div>
            </main>
            <footer id='foot'></footer>
        </div>
    );
}

export default App;